import { render, staticRenderFns } from "./editinformasi.vue?vue&type=template&id=90b69048&"
import script from "./editinformasi.vue?vue&type=script&lang=js&"
export * from "./editinformasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports